import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontBold } from 'style/styled-components/cssGlobalVariables';
import { ellipsis } from 'style/styled-components/reusable.css';

export const ChannelImageWrapper = styled.div`
    position: absolute;
    width: calc(100% - 64px);
    height: calc(100% - 32px);
    overflow: hidden;
    left: 32px;
    top: 16px;

    img {
        width: 100%;
        object-fit: contain;
    }
`;

export const ChannelNumber = styled.span`
    position: absolute;
    left: 8px;
    top: 8px;
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 12px;
    line-height: 16px;
    font-family: ${fontBold};
`;

export const ChannelIcon = styled.span`
    position: absolute;
    right: 8px;
    top: 8px;
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    font-size: 12px;
    line-height: 16px;
    font-family: ${fontBold};

    svg {
        path {
            fill: ${(props) => props.theme.brandedConfig.high_contrast};
        }
    }
`;

export const ChannelFallbackTitle = styled.span`
    position: absolute;
    width: calc(100% - 64px);
    left: 32px;
    top: 50%;
    transform: translateY(-50%);
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    ${ellipsis(1)};
    text-align: center;
    line-height: 24px;
    font-family: ${fontBold};
`;
